const GetAgentsUrl = '/admin/api/agents';
const PostAgentUrl = '/admin/api/agents/';
const GetAgentUrl = (id: number) => `/admin/api/agents/${id}`;
const PutAgentUrl = (id: number) => `/admin/api/agents/${id}`;
const DeleteAgentUrl = (id: number) => `/admin/api/agents/${id}`;

export { GetAgentsUrl, PostAgentUrl, GetAgentUrl, PutAgentUrl, DeleteAgentUrl };